import { type ReactNode } from 'react';
import { formatMinSec } from '@/core/required-videos-time';
import { useRequiredVideoStatus } from './required-video-context';

const TXT = 'text-center text-xs text-text-secondary';

type Props = {
  lockedLabel?: (time: ReactNode) => ReactNode;
};

export function RequiredVideoCaption({ lockedLabel }: Props = {}): ReactNode {
  const { completed, remainingSecs, loading, available } =
    useRequiredVideoStatus();
  if (completed) return null;
  if (loading) return <p className={TXT}>Cargando v&iacute;deo&hellip;</p>;
  if (!available) return null;
  if (remainingSecs <= 0) {
    return <p className={TXT}>Pulsa Reproducir para empezar</p>;
  }
  const time = (
    <span className="font-mono tabular-nums">
      {formatMinSec(remainingSecs)}
    </span>
  );
  if (lockedLabel) return <p className={TXT}>{lockedLabel(time)}</p>;
  return <p className={TXT}>Faltan {time} min para desbloquear</p>;
}
